
import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";
import { EEventType } from "./enums/eventType";
import { Intervention } from "./intervention";
import { User } from "./user";

export class Event {

    /** ID SERVER */
    @AutoMap()
    Code!: string;
    @AutoMap()
    Type!: EEventType;
    @AutoMap()
    From!: Temporal.PlainDateTime;
    @AutoMap()
    To!: Temporal.PlainDateTime;
    @AutoMap()
    Titre!: string;
    @AutoMap()
    Description?: string;

    @AutoMap()
    Sampler: User = new User();

    @AutoMap()
    Intervention: Intervention = new Intervention();

    public constructor(init?: Partial<Event>) {
        Object.assign(this, init);
    }
}